<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="var(--palette-gray-90)"
        stroke-width="2">
        <circle
            cx="12"
            cy="5"
            r="1" />
        <circle
            cx="19"
            cy="5"
            r="1" />
        <circle
            cx="5"
            cy="5"
            r="1" />
        <circle
            cx="12"
            cy="12"
            r="1" />
        <circle
            cx="19"
            cy="12"
            r="1" />
        <circle
            cx="5"
            cy="12"
            r="1" />
        <circle
            cx="12"
            cy="19"
            r="1" />
        <circle
            cx="19"
            cy="19"
            r="1" />
        <circle
            cx="5"
            cy="19"
            r="1" />
    </svg>
</template>

<script>
export default {
    name: 'PendoProductsIcon',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
};
</script>
